import { Modal } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { ConfirmModal } from 'hooks/useConfirmModal'

const LogoDeletionConfirmationModal = ({ onConfirm, onCancel, onPressOutside }: ConfirmModal) => {
  return (
    <Modal.Root onPressOutside={onPressOutside}>
      <Modal.Header title="Delete logo?" />
      <Modal.Content>
        <Text>You'll need to upload a new one later. This can't be undone.</Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton id="delete-logo-cancel" variant="tertiary" onPress={onCancel}>
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton aria-label="Confirm delete logo" onPress={onConfirm}>
            Delete
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}

export { LogoDeletionConfirmationModal }
